import { DatePipe, NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-notification-message',
  imports: [DatePipe, NgClass],
  templateUrl: './notification-message.component.html',
  styleUrl: './notification-message.component.scss',
})
export class NotificationMessageComponent {
  @Input() notificationDate = new Date();
  @Input() viewed = false;
  @Input() title = '';
  @Input() body = '';
  @Input() notificationId = 0;
  @Input() isChecked = false;
  @Output() checkedChange = new EventEmitter<number>();

  isContentHover = false;

  toggleCheck() {
    this.checkedChange.emit(this.notificationId);
  }
}
